import { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Container } from '@mui/material';
import { checkFile, ConditionalWrapper, getManagerSearchParams, isIframe, isMobileApp } from '../Utilities';
import { isMobile, useMobileOrientation } from 'react-device-detect';
import Weather from "./Weather"
import Settings from './Settings';
import Stats from './Stats';
import Logo from './Logo';
import Support from './Support';
import Menu from './Menu';
import ManagerControls from './ManagerControls';
import AppStoreLinks from './AppStoreLinks';

export default function Header() {

    const { LAYOUT: { LOGO, INVERTED_COLORS, TITLE }, STATS } = window.conf
    const { isPortrait } = useMobileOrientation()
    const { isSingleProject } = getManagerSearchParams()

    const netcoColor = window.localStorage.getItem('netco_color')
    const hasManagerControls = isIframe && !isSingleProject

    const [invertColors, setInvertColors] = useState(netcoColor ? netcoColor === "true" : INVERTED_COLORS)
    const [logoSrc, setLogoSrc] = useState(null)
    const [isSupportOpen, setIsSupportOpen] = useState(false)

    const handleOpenSupport = () => setIsSupportOpen(true)
    const handleCloseSupport = () => setIsSupportOpen(false)

    useEffect(() => {
        const checkLogo = async() => {
            const { exists, contentType } = await checkFile(LOGO)
            if (exists && contentType === 'image') {
                setLogoSrc(LOGO)
            }
        }
        checkLogo()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const toggleInvertColors = () => {
        var toggledColors = !invertColors
        setInvertColors(toggledColors)
        window.localStorage.setItem('netco_color', toggledColors)
    }
    
    return (
        <AppBar 
            position="sticky" 
            sx={{ 
                zIndex: theme => isPortrait ? theme.zIndex.drawer - 1 : theme.zIndex.drawer + 1, 
                backgroundColor: invertColors ? 'primary.main' : 'secondary.main'
            }}
        >
            <Container maxWidth={false}>
                <Toolbar 
                    disableGutters
                    variant={isMobile ? 'dense' : "regular"}
                >

                    {/* logo */}

                    {!hasManagerControls && (
                        <Logo 
                            src={logoSrc}
                            invertColors={invertColors}
                        />
                    )}

                    {/* manager controls */}

                    <ConditionalWrapper
                        condition={hasManagerControls}
                        wrapper={children => (
                            <ManagerControls invertColors={invertColors}>
                                {children}
                            </ManagerControls>
                        )}
                    >
                        {/* title */}

                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{ 
                                flexGrow: !hasManagerControls && 1,
                                minWidth: 0,
                                px: { xs: hasManagerControls && 0.5, sm: 1 },
                                userSelect: "none",
                                fontSize: { xs: '1rem', sm: '1.33rem' },
                                color: invertColors ? 'white' : 'primary.main',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {TITLE || "Portal"}
                        </Typography>

                    </ConditionalWrapper>

                    {/* app store links */}

                    {!isMobileApp && (window.conf.LAYOUT.APPSTORELINKS || false) && <AppStoreLinks invertColors={invertColors} />}
                    
                    {/* weather */}

                    <Weather />

                    {/* statistics */}

                    {STATS.ENABLED && <Stats invertColors={invertColors} />}

                    {/* menu */}

                    <Menu invertColors={invertColors} />

                    {/* settings */}

                    <Settings
                        invertColors={invertColors}
                        toggleInvertColors={toggleInvertColors}
                        handleOpenSupport={handleOpenSupport}
                    />

                    {/* support */}
                    
                    {(window.conf.LAYOUT.SUPPORT || false) && (
                        <Support
                            invertColors={invertColors}
                            isOpen={isSupportOpen}
                            handleOpen={handleOpenSupport}
                            handleClose={handleCloseSupport}
                        />
                    )}

                </Toolbar>
            </Container>
        </AppBar>
    )
}